import React from 'react';
import styled from 'styled-components';

import { Container, Button, Spinner } from 'ui/components/styled';
import device from 'ui/theme/device';

export const Loader = () => (
  <SpinnerContainer>
    <Spinner centered />
  </SpinnerContainer>
);

const SpinnerContainer = styled(Container)`
  height: auto;
  min-height: 80px;
  align-items: center;
`;

export const Row = styled(Container)`
  flex-direction: row;
  background-color: #f5f9ff;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 10px 15px;
  border-radius: 5px;
  &:not(:first-child) {
    margin-top: 10px;
  }
`;

export const ActionButton = styled(Button)`
  width: auto;
  box-shadow: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  padding: 6px 10px;
  @media ${device.small} {
    font-size: 12px;
    padding: 4px 4px;
  }
`;
